export default __webpack_public_path__ + "static/pink-shopping-bag-40a10740f6b564e6432e35d40afce893.jpg";